import { render } from "./DocumentChips.vue?vue&type=template&id=791559de&scoped=true"
import script from "./DocumentChips.vue?vue&type=script&lang=js"
export * from "./DocumentChips.vue?vue&type=script&lang=js"

import "./DocumentChips.vue?vue&type=style&index=0&id=791559de&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791559de"]])

export default __exports__